module.exports = __webpack_public_path__ + "fonts/Clash-Light.b3d95b9.woff2";